/* eslint-disable @next/next/no-img-element */
import React from "react";
import { PropertyDataInterface } from "./PropertyCardGridView";
import BrandedButton from "../../../../shadcn/components/custom/BrandedButton";
import { Card } from "../../../../shadcn/components/ui/card";
import { formatNumber, normalizeUrl } from "services";
import VerifiedHammer from "../../../../icons/VerifiedHammer";

export interface PropertyCardListViewPropsInterface {
  onCardClick: (property: PropertyDataInterface) => void;
  property: PropertyDataInterface;
  onRequestImagesClick: (property: PropertyDataInterface) => void;
}

export const PropertyCardListView: React.FC<
  PropertyCardListViewPropsInterface
> = ({
  onCardClick = (_property) => {},
  property,
  onRequestImagesClick = () => {},
}) => {
  return (
    <Card
      className="flex flex-col sm:flex-row gap-3 p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow bg-white capitalize"
      onClick={() => onCardClick?.(property)}
    >
      <div className="relative w-full sm:w-[120px] h-[180px] sm:h-[90px] flex-shrink-0">
        {property?.hasImage ? (
          <img
            src={property?.propertyImageUrl}
            alt={property?.title}
            className="w-full h-full object-cover rounded"
            onError={(e) => {
              e.currentTarget.style.display = "none";
              e.currentTarget.nextElementSibling?.classList.remove("hidden");
            }}
          />
        ) : (
          <div
            className={`absolute inset-0 bg-gray-100 text-gray-500 text-xs flex items-center justify-center`}
          >
            <p>Images not available</p>
          </div>
        )}

        <div className="absolute top-2 left-2 bg-white border border-orange-500 text-orange-600 px-2 py-1 rounded-full text-xs font-semibold">
          {property?.listingId || "N/A"}
        </div>
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex gap-2">
          <h3 className="font-semibold text-gray-900 mb-1 truncate">
            {property?.title}
          </h3>
          {property?.isVerified && (
            <div>
              <VerifiedHammer />
            </div>
          )}
        </div>

        <div className="mb-1">
          <span className="text-orange-600 font-bold text-lg ">
            ₹{formatNumber(property?.price)}
          </span>
          <span className="text-sm"> • {property?.priceTag}</span>
        </div>
        {property?.propertyType === "auction-properties" && (
          <div className="text-sm text-gray-600 mb-1">
            Bank: {property?.bankName}
          </div>
        )}

        <div className="text-xs text-gray-500">
          <span>
            {property?.propertyType === "auction-properties"
              ? `Auction: ${property?.auctionDate} | `
              : property?.propertyType === "private-properties"
              ? `Area: ${property?.area}`
              : ""}
          </span>
          {property?.propertyType === "auction-properties"
            ? `${property?.possession}`
            : ""}
        </div>
      </div>

      <div className="flex w-full sm:w-auto items-start sm:items-center flex-col sm:flex-row gap-2 sm:ml-auto">
        <BrandedButton
          variant="primary"
          size="md"
          className="w-full sm:w-auto"
          onClick={() => {
            window.open(
              normalizeUrl(
                `${process.env.NEXT_PUBLIC_WEB_URL}/${property?.propertyType}/${property?.listingId}`,
              ),
              "_blank",
            );
          }}
        >
          View Details
        </BrandedButton>

        {property?.showRequestImagesCta && (
          <BrandedButton
            variant="outline"
            onClick={() => {
              onRequestImagesClick?.(property);
            }}
            className="w-full sm:w-auto"
          >
            Request Images
          </BrandedButton>
        )}
      </div>
    </Card>
  );
};
